import { useState } from "react";
import { Menu } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import { IconButtonStyled } from "./styles/SimpleMenuErp";

const SimpleMenuErp = ({ icon = <></>, actions = [], iconSize = "small" }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButtonStyled
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        size={iconSize}
      >
        {icon}
      </IconButtonStyled>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {actions.map((e, i) => (
          <MenuItem onClick={e.onClick} disabled={e.disabled} key={i}>
            {e.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default SimpleMenuErp;
